import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success');

  useEffect(() => {
    // Don't redirect if they just completed payment (let SubscribePage handle it)
    if (success === 'true') {
      return;
    }

    const trialExpired = user?.subscription_status === 'trial' && user?.trial_end_date
      ? new Date(user.trial_end_date) < new Date()
      : false;
    
    // If user is logged in but inactive, redirect to subscribe (except if already on subscribe page)
    if (user && (user.subscription_status === 'inactive' || trialExpired) && location.pathname !== '/subscribe') {
      navigate('/subscribe');
    }
  }, [user, location.pathname, navigate, success]);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '60px',
            height: '60px',
            border: '4px solid #4A90E2',
            borderTop: '4px solid transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }} />
          <p style={{ fontSize: '1.2rem', color: '#666' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
